<template>
  <el-drawer :visible.sync="visible" :before-close="closeFn" size="62%">
    <h1 style="margin-bottom:30px;">编辑车辆</h1>

    <el-dialog :title="viewTitle" :visible.sync="viewVisible" @close="viewPages = { page: 1, size: 20 }" width="40%"
      append-to-body>
      <el-table :data="viewData" v-loadmore="listFnPush" :loading="viewLoading" :max-height="577" style="width: 100%"
        border>
        <el-table-column prop="xianlu" width="400" label="参与线路">
        </el-table-column>
        <el-table-column prop="banci" label="已排班次"> </el-table-column>
      </el-table>
    </el-dialog>

    <p slot="titl">
      {{ line.startStationName }} - {{ line.endStationName }}
      <template v-if="line && line.schedulingType === 1">
        {{ scheduling.schedulingTime | filterTime("MM-DD") }}
        {{ scheduling.startTime }}
        <span v-if="scheduling.startTime && scheduling.endTime">-</span>
        {{ scheduling.endTime }}
      </template>
    </p>
    <div style="height: auto">
      <custom-table @onRowClick="onRowClick" @listBack="listBack" ref="customTable" :customOptions="customOptions"
        :columns="columns" class="scheduling-vehicle" :show-overflow-tooltip="false" labelWidth="140"
        :organizationId="line.organizationId || null" addText="" layout="total, prev, pager, next" maxHeight="409"
        :loadmoreSwitch="true">
        <template slot="table-operation">
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="{ row }">
              <el-checkbox v-if="row.driverId && (line.schedulingType == 3 ? row.vehicleSeat <= 9 : true)"
                :value="checkList.findIndex((item) => item.driverId == row.driverId) > -1"
                :disabled="checkListOld.findIndex((item) => item.driverId === row.driverId) > -1"></el-checkbox>
            </template>
          </el-table-column>
        </template>

        <template slot-scope=" { item, row }">
          <template v-if="item.prop === 'vehicleSeat'">
            {{ row.vehicleSeat }}座
          </template>
          <template v-else-if="item.prop === 'schedulingCount'">
            <span v-if="row.schedulingCount" style="
                  color: #0066ff;
                  cursor: pointer;
                  text-decoration: underline;
                " @click.stop="lineVehicleListView(row)">
              {{ row.schedulingCount }}</span>
            <span v-else>空闲</span>
          </template>

          <template v-else>{{
            row[item.prop] ? row[item.prop] : "-"
          }}</template>
        </template>
      </custom-table>
    </div>

    <!--座位插槽-->
    <slot></slot>

    <el-form v-if="line.schedulingType === 3" :model="form ? form : forms" :rules="rules" ref="form" label-width="114px">
      <!-- 座位价格设置 -->
      <div v-if="listRows" class="cont">
        <div class="cont-left">
          <div class="driverslist" v-show="form.vehicleSeat.length != 0">
            <div class="driver"></div>
            司机
          </div>

          <div :class="form.vehicleSeat.length == 4
            ? 'passe1'
            : form.vehicleSeat.length == 6
              ? 'passe2'
              : form.vehicleSeat.length == 7
                ? 'passe3'
                : form.vehicleSeat.length == 8
                  ? 'passe4'
                  : ''
            " class="zuoweo" v-for="(item, index) in form.vehicleSeat" :key="index">
            <div class="passenger"></div>
            <p>{{ item.seatNo }}</p>
          </div>
        </div>

        <div class="cont-right">
          <div style="display: flex" v-for="(item, index) in form.vehicleSeat" :key="index">
            <span class="driver-number">{{ item.seatNo }}</span>
            <el-input maxlength="3" @input="item.fee = item.fee.replace(/[^\d]/g, '').replace(/^0/g, '0')"
              v-model="item.fee" placeholder="请设置座位价格">
              <p class="input-suffix" slot="suffix">元</p>
            </el-input>
          </div>
        </div>
      </div>
      <br />
    </el-form>
    <div v-if="listRows" style="text-align: center; margin: 20px">
      <el-button type="primary" @click="save" style="width:50%">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "scheduling2",
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const sign = 1;
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= sign) {
            binding.value();
          }
        });
      },
    },
  },
  props: {
    line: {
      default() {
        // 线路信息
        return {};
      },
    },
    scheduling: {
      // 班次信息
      default() {
        return {};
      },
    },
    multiple: {
      // 是否多选
      default() {
        return true;
      },
    },
    list: {
      // 初始值
      default() {
        return [];
      },
    },
    drivers: {
      // 初始值
      default() {
        return [];
      },
    },
    visible: {
      // 显示隐藏
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      viewLoading: false,
      viewTitle: "",
      viewVisible: false,
      viewData: [],
      viewPages: {
        page: 1,
        size: 20,
      },
      // 表单
      form: {
        vehicleSeat: [],
      },
      Dataresult: {
        result: [],
      },
      // 校验规则
      rules: {},
      // 保存按钮loading
      loading: false,
      listRows: false,
      dialogVisible2: false,
      checkList: [], // 选择结果
      checkListOld: [], // 传入的原有数据
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/line/vehicle/duty",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 15, // 每页条数
          channel: 1
        },
        search: [
          {
            type: "input",
            field: "licenseNo",
            name: "车辆号牌",
            value: "",
          },
          {
            type: "input",
            field: "driverName",
            name: "值班司机",
            value: "",
          },
          {
            type: "select",
            field: "exist",
            name: "是否存在值班司机",
            value: "",
            option: this.$const.EXIST,
          },
        ],
      },
      columns: [
        { prop: "organizationName", label: "机构名称" },
        { prop: "licenseNo",width: 100, label: "车辆号牌" },
        { prop: "vehicleSeat", width: 120, label: "座位数" },
        { prop: "driverName", width: 150, label: "值班司机" },
        { prop: "schedulingCount", width: 150, label: "已排班数" },
      ],
    };
  },
  watch: {
    visible: {
      handler(val) {
        console.log('val::: ', val);
        if (val) {
          this.$nextTick(() => {
            this.customOptions.params.organizationId = this.line.organizationId
            this.checkList = this.$utils.deepCopyFn(this.drivers);
            this.checkListOld = this.$utils.deepCopyFn(this.drivers);
            this.id = "";
            setTimeout(() => {
              this.list.forEach((item) => {
                if (this.checkList.length > 0) {
                  if (item.id === this.checkList[0].id) {
                    this.listRows = true;
                    this.form.vehicleSeat = this.scheduling.schedulingVehicleJson ? this.scheduling.schedulingVehicleJson[0].vehicleSeatAndFeeVos : null;
                  }
                }
              });
            }, 800);
          });
        } else {
          this.listRows = false;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    checkboxChange(event) {

    },
    async lineVehicleListView(row) {
      this.vehicleId = row.vehicleId;
      let params = {
        ...this.viewPages,
        vehicleId: this.vehicleId,
      };
      let formIURL = "/api/v1/manage/line/vehicle/duty/scheduling";
      let data = await this.$axios.get(formIURL, params);
      if (data && data.code === 1) {
        data.data.forEach((item) => {
          item.xianlu = item.startStationName + " - " + item.endStationName;
          item.banci =
            this.$utils.timeFn(item.schedulingTime, "MM-DD") +
            " " +
            item.startTime +
            "-" +
            item.endTime;
        });
        this.viewData = data.data || [];
      }
      this.viewTitle = row.licenseNo + " " + row.vehicleSeat + "座 " + row.driverName;
      this.viewVisible = true;
    },
    /**
     * 滚动分页
     */
    async listFnPush() {
      if (this.viewPages.total <= this.viewPages.page * this.viewPages.size) {
        return;
      }
      this.loading = true;

      let formIURL = "/api/v1/manage/line/vehicle/duty/scheduling";
      this.viewPages.page = this.viewPages.page + 1;
      let params = {
        ...this.viewPages,
        vehicleId: this.vehicleId,
      };
      let data = await this.$axios.get(formIURL, params);

      if (data && data.code === 1) {
        data.data.forEach((item) => {
          item.xianlu = item.startStationName + " - " + item.endStationName;
          item.banci =
            this.$utils.timeFn(item.schedulingTime, "MM-DD") +
            " " +
            item.startTime +
            "-" +
            item.endTime;
        });
        this.viewData = this.viewData.concat(data.data) || [];
        this.viewPages.total = data.total || 0;
      }
      this.viewLoading = false;
    },
    listBack(e) {
      Object.assign(this.list, e);
    },
    //模态框
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => { });
    },
    save() {
      let seactrbing = true;
      let a = false;
      if (this.form.vehicleSeat) {
        this.form.vehicleSeat.forEach((item) => {
          if (item.fee < 0 || item.fee === null) {
            seactrbing = false;
            a = true;
          }
        });
      }
      if (this.line.schedulingType == 3 && (!this.form.vehicleSeat || !this.form.vehicleSeat.length || this.form.vehicleSeat.length == 0)) {
        this.$message.warning("座位数据获取异常，请刷新后再试");
        return;
      }
      if (a) {
        this.$message.warning("请输入座位价格后保存");
        return;
      }
      if (seactrbing) {
        this.$emit("update:visible", false);
        this.checkList.forEach((item) => {
          item.vehicleSeatAndFeeVos = this.form.vehicleSeat;
        });
        this.$emit("confirm", this.checkList);
        this.listRows = false;
      }
    },

    async onRowClick(obj) {
      if (this.checkListOld.find(item => item.driverId == obj.driverId)) {
        return;
      }
      if (this.line.schedulingType == 3 && obj.vehicleSeat > 9) {
        return;
      }
      if (obj.driverName == null) {
        this.$message.closeAll();
        this.$message.warning("所选车辆没有值班司机，无法添加");
        return;
      }
      if (this.drivers.length > 0) {
        if (this.drivers[0].id === obj.id) {
          this.form.vehicleSeat = this.scheduling.schedulingVehicleJson
            ? this.scheduling.schedulingVehicleJson[0].vehicleSeatAndFeeVos
            : null;
        } else {
          if (this.line.schedulingType === 3) {
            //获取座位
            let url = "/api/v1/manage/line/vehicle/config";
            let params = {
              vehicleSeat: obj.vehicleSeat,
            };
            let data = await this.$axios.get(url, params);
            if (data && data.code === 1) {
              data.data.forEach((item) => {
                item.id = null;
              });
              this.form.vehicleSeat = data.data;
            }
          }
        }
      } else {
        if (this.line.schedulingType === 3) {
          //获取座位
          let url = "/api/v1/manage/line/vehicle/config";
          let params = {
            vehicleSeat: obj.vehicleSeat,
          };
          let data = await this.$axios.get(url, params);
          if (data && data.code === 1) {
            this.form.vehicleSeat = data.data;
          }
        }
      }

      this.listRows = true;

      let row = this.$utils.deepCopyFn(obj);

      delete row.lineVehicleList;
      delete row.schedulingCount;

      if (this.multiple) {
        let index = this.checkList.findIndex((item) => item.id === row.id);
        if (index > -1) {
          this.checkList.splice(index, 1);
        } else {
          if (row.driverId) {
            if (row.organizationId !== this.line.organizationId) {
              this.$message.warning("所选车辆与当前线路不在同一机构，无法添加");
              return;
            }
            this.checkList.push(row);
          }
        }
      } else {
        if (row.driverId) {
          if (row.organizationId !== this.line.organizationId) {
            this.$message.warning("所选车辆与当前线路不在同一机构，无法添加");
            return;
          }
          this.checkList = [row];
        }
      }
    },
    closeFn(done) {
      this.$emit("update:visible", false);
      done(false);
    },
  },
};
</script>

<style lang="less">
.el-drawer__header {
  right: 6%;
}

.scheduling-vehicle {
  .icon-checked {
    color: @color-primary;
  }

  .line-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  #customSearch .customTable-top .grouping-field {
    display: grid;
    overflow: hidden;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

    .grouping-field-item {
      min-width: 200px !important;
    }
  }
}

.cont {
  display: flex;
  text-align: center;
  margin: 32px auto 0;

  .cont-left {
    display: flex;
    flex-wrap: wrap;
    width: 300px;

    .driverslist {
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-left: 60px;
    }

    .passe1 {
      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 30px;
      }

      &:nth-child(4) {
        margin-left: 40px;
      }

      &:nth-child(5) {
        margin-left: 40px;
      }
    }

    .passe2 {
      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 60px;
      }

      &:nth-child(4) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(5) {
        margin-left: 40px;
      }

      &:nth-child(6) {
        margin-left: 30px;
      }

      &:nth-child(7) {
        margin-left: 40px;
      }
    }

    .passe3 {
      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 30px;
      }

      &:nth-child(4) {
        margin-left: 40px;
      }

      &:nth-child(5) {
        margin: 0 40px;
      }

      &:nth-child(6) {
        margin-left: 30px;
      }

      &:nth-child(7) {
        margin-left: 40px;
      }

      &:nth-child(8) {
        margin-left: 40px;
      }
    }

    .passe4 {
      >p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }

      &:nth-child(2) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(3) {
        margin-left: 60px;
      }

      &:nth-child(4) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(5) {
        margin-left: 60px;
      }

      &:nth-child(6) {
        margin-left: 60px;
        margin-right: 60px;
      }

      &:nth-child(7) {
        margin-left: 40px;
      }

      &:nth-child(8) {
        margin-left: 30px;
      }

      &:nth-child(9) {
        margin-left: 40px;
      }
    }

    .driver {
      width: 40px;
      height: 40px;
      background: #ccc;
      background: url("../../../assets/img/zuowei2.png");
    }

    .passenger {
      width: 40px;
      height: 40px;
      background: url("../../../assets/img/zuowei1.png") 100% 100%;
    }
  }

  .cont-right {
    margin-left: 20px;

    .driver-number {
      margin-right: 10px;
      display: inline-block;
      color: #333333;
      width: 36px;
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
    }

    .input-suffix {
      font-size: 13px;
      font-weight: bold;
      line-height: 28px;
      color: #333333;
      padding: 0 6px 0 0;
    }

    >div {
      margin-bottom: 16px;
    }
  }
}

.head {
  display: flex;

  p {
    line-height: 28px;
    display: flex;
    align-items: center;
    color: #999999;
  }
}

.titl {
  border-left: 4px solid #409efc;
  color: #333333;
  width: 550px;
  height: 27px;
  font-size: 20px;
  font-weight: 600;
  line-height: 27px;
  color: #333333;
  opacity: 1;
  text-indent: 6px;
  display: flex;
  justify-content: space-between;
}

.dian {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #999999;
  border-radius: 50%;
  opacity: 1;
  margin-right: 6px;
}

// 禁用input的number箭头
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
